import React from "react";
import { Badge } from "@fluentui/react-components";
import { observer } from "owa-mobx-react";

interface OwaHeaderButtonBadgeProps {
    id: string;
    getCount: () => number;
    className?: string;
}

const OwaHeaderButtonBadge: React.FC<OwaHeaderButtonBadgeProps> = observer(({ id, getCount, className }) => {
    const badgeCount = getCount();
    
    if (badgeCount <= 0) {
        return null;
    }
    
    return (<Badge id={id} appearance="filled" color="danger" size="small" className={className}>
                {badgeCount}
            </Badge>);
}, "OwaHeaderButtonBadge");

export default OwaHeaderButtonBadge;
